@import '../../theme/global.scss';

:host {
  align-items: center;
  display: flex;
  justify-content: center;

  .app-switcher-container {
    border-right: 1px solid $gray-300;
    display: flex;

    snap-app-switcher {
      margin-right: 0.5rem;

      @media (min-width: map-get($breakpoints, 'md')) {
        margin-right: 0.813rem;
      }
    }
  }

  snap-session {
    margin-left: 22px;
  }
}

